<template>
    <div id="search">
      <div class="layout">
        <div class="stat-type-wrap">
          <div class="search-result-wrap">
            <ul class="align-center all-search-tab">
              <li :class="{on: searchTabs === 1}"><a href="#/" @click.prevent="showDataMapChart()">데이터맵</a></li>
              <li :class="{on: searchTabs === 2}"><a href="#/" @click.prevent="showCategory()">분류검색</a></li>
            </ul>
            <div v-show="searchTabs === 1">
              <div class="search-result date-none">
                <DataMapChart :searchParams="this.dataMapParams" ref="dataMapChart"/>
              </div>
            </div>
            <div v-show="searchTabs === 2">
              <div class="category-graph">
                <ul v-for="(item, index) in tagList" :key="index" class="graph-item" :data-total="item.cnt" :data-name="item.tagName" @click="searchRetrieve(1, 0, item.tagName)">
                  <li v-for="n in 10" :key="n" :class="{ 'on': n <= getOnCount(item.cnt) }"></li>
                </ul>
              </div>
              <div class="search-result date-none">
                <span class="total">게시물 검색결과 <span class="num">{{ tagNoticeTotalCount }}</span>건</span>
                <ul class="search-result-list">
                  <li v-for="(data, idx) in tagNoticeList" v-bind:key="idx" class="result-item" >
                    <router-link v-if="data.contentType == '000316'" :to="{name: '기타자료실 상세', query: {boardId: data.boardId, boardType: '000035', target: '기타자료실'} }" @click="goInfographic(data.descriptionUrl)">
                      <div class="title-address">
                        <strong class="result-title" v-html="data.noticeName"></strong>
                        <div class="address">기타자료실</div>
                      </div>
                      <ul class="tag-list">
                        <li v-for="(tag, tagIdx) in data.noticeTagName.split(' ').map(t => t.trim())" :key="tagIdx" class="tag-box" :class="{ 'highlight-tag': tag === normalizedFindNm }">
                          {{ tag }}
                        </li>
                      </ul>
                    </router-link>
                    <router-link v-if="data.contentType == '000315'" :to="{name: '지표보고서 상세', query: {boardId: data.boardId, boardType: '000311', target: '지표보고서'} }" @click="goInfographic(data.descriptionUrl)">
                      <div class="title-address">
                        <strong class="result-title" v-html="data.noticeName"></strong>
                        <div class="address">지표보고서</div>
                      </div>
                      <ul class="tag-list">
                        <li v-for="(tag, tagIdx) in data.noticeTagName.split(' ').map(t => t.trim())" :key="tagIdx" class="tag-box" :class="{ 'highlight-tag': tag === normalizedFindNm }">
                          {{ tag }}
                        </li>
                      </ul>
                    </router-link>
                  </li>
                  <li v-show="tagNoticeList == null || tagNoticeList == ''">
                    <a class="non-data" style="cursor:default;">
                      <div class="notice-content">
                        <strong>검색결과가 없습니다.</strong>
                      </div>
                    </a>
                  </li>
                </ul>
                <SearchPagination :pageSetting="pageDataSetting(this.tagNoticePage, this.tagNoticeTotalCount, this.tagNoticeRows)" @paging="pagingTagNoticeMethod"/>
              </div>
              <div class="search-result date-none">
                <span class="total">통계보고서 검색결과 <span class="num">{{ tagStatTotalCount }}</span>건</span>
                <ul class="search-result-list">
                  <li v-for="(data, idx) in tagStatList" v-bind:key="idx" class="result-item">
                    <a href="#/" @click="goStatReport(data)">
                      <div class="title-address">
                        <strong class="result-title" v-html="data.statRptNm"></strong>
                        <div class="address">통계보고서</div>
                      </div>
                      <ul class="tag-list">
                        <li v-for="(tag, tagIdx) in data.statTagName.split(' ').map(t => t.trim())" :key="tagIdx" class="tag-box" :class="{ 'highlight-tag': tag === normalizedFindNm }">
                          {{ tag }}
                        </li>
                      </ul>
                    </a>
                  </li>
                  <li v-show="tagStatList == null || tagStatList == ''">
                    <a class="non-data" style="cursor:default;">
                      <div class="notice-content">
                        <strong>검색결과가 없습니다.</strong>
                      </div>
                    </a>
                  </li>
                </ul>
                <SearchPagination :pageSetting="pageDataSetting(this.tagStatPage, this.tagStatTotalCount, this.tagStatRows)" @paging="pagingTagStatMethod"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>

<script>
import * as api from '@/api/Statistics.js'
import * as searchApi from '@/api/Search.js'
import * as statReportApi from '@/api/StatReport.js'
import * as noticeApi from '@/api/Notice.js'
import $, { param } from 'jquery'
import SearchPagination from '@/components/SearchPagination'
import SearchStatDetail from '@/components/SearchStatDetail'
import DataMapChart from '@/components/chart/DataMapChart'

export default {
	name: 'SearchSort',

	components: {
		SearchPagination,
		SearchStatDetail,
		DataMapChart
	},

	data () {
		return {
			searchTabs: 1,
			findNm: '',
			searchFindNm: this.$route.query.searchFindNm,
			block: 10,
			// 데이터맵 데이터
			dataMapParams: [
				{
					tblKorNm: '문화',
					tblMgmNo: 'STBL-1014250'
				},
				{
					tblKorNm: '예술',
					tblMgmNo: 'STBL-1030638'
				},
				{
					tblKorNm: '콘텐츠',
					tblMgmNo: 'STBL-1014252'
				},
				{
					tblKorNm: '관광',
					tblMgmNo: 'STBL-1014253'
				},
				{
					tblKorNm: '스포츠',
					tblMgmNo: 'STBL-1014255'
				},
				{
					tblKorNm: '종합',
					tblMgmNo: 'STBL-1030639'
				}
			],
			main: this.$route.query.main,
			mainTblMgmNo: this.$route.query.tblMgmNo,
			// 태그검색 데이터
			tagList: [],
			// 통계보고서 태그검색 데이터
			tagStatList: [],
			tagStatTotalCount: 0,
			tagStatRows: 3,
			tagStatPage: 1,
			// 게시판 태그검색 데이터
			tagNoticeList: [],
			tagNoticeTotalCount: 0,
			tagNoticeRows: 3,
			tagNoticePage: 1
		}
	},

	created () {
		this.searchRetrieve(this.page, 0)

		this.selectTagCount().then(() => {
			if (this.tagList.length > 0) {
				const firstTag = this.tagList[0].tagName
				this.searchRetrieve(1, 0, firstTag)
			}
		})

		// 메인에서 데이터맵 클릭해서 들어왔을 때
		if (this.main === 'Y') {
			this.searchTabs = 1
			this.mainDataMap()
		}
	},

	mounted () {
		if (window.innerWidth <= 768) {
			this.block = 5
		}
	},

	watch: {
		$route (to, from) {
			if (to.path == from.path) {
				this.searchRetrieve(this.page, 0)
			}
		}
	},

	computed: {
		total () {
			return this.tagList.reduce((sum, item) => sum + item.cnt, 0)
		},

		normalizedFindNm () {
			return this.findNm.startsWith('#') ? this.tagName : `#${this.tagName}`
		}
	},

	methods: {
		async mainDataMap () {
			await this.$nextTick()
			const tblMgmNo = this.mainTblMgmNo
			this.$refs.dataMapChart.statisticsMapSearchList(tblMgmNo)
		},

		searchRetrieve (currentPage, startPage, tagName) {
			this.tagName = tagName
			this.findNm = tagName
			this.searchTagStatList(currentPage, startPage, tagName)
			this.searchTagNoticeList(currentPage, startPage, tagName)
		},

		// 태그 개수 불러오기
		async selectTagCount (paramData) {
			try {
				const response = await searchApi.selectTagCount(paramData)
				this.tagList = response.data || []
			} catch (error) {
				console.error('selectTagCount Error : ', error)
			}
		},

		getOnCount (itemTotal) {
			const percentage = (itemTotal / this.total) * 100
			return Math.round(percentage / 5) // 반올림
		},

		// 게시판 태그 검색
		async searchTagNoticeList (currentPage, startPage, tagName) {
			this.tagNoticeTotalCount = 0
			const paramData = {
				findNm: tagName,
				startIdx: startPage * this.tagNoticeRows + 1,
				endIdx: startPage * this.tagNoticeRows + this.tagNoticeRows
			}
			const searchTagNoticeList = await searchApi.searchTagNoticeList(paramData)
			this.tagNoticeList = searchTagNoticeList.data

			if (searchTagNoticeList.data && searchTagNoticeList.data.length > 0) {
				this.tagNoticeTotalCount = searchTagNoticeList.data[0].totalCount
			} else {
        this.tagNoticeTotalCount = 0;
      }

			this.tagNoticePage = currentPage
			this.pageDataSetting(currentPage, this.tagNoticeTotalCount, this.tagNoticeRows)
		},

		pagingTagNoticeMethod (page) {
			const startRow = page - 1
			this.searchTagNoticeList(page, startRow, this.tagName)
		},

		// 통계보고서 태그 검색
		async searchTagStatList (currentPage, startPage, tagName) {
			this.tagStatTotalCount = 0
			const paramData = {
				findNm: tagName,
				startIdx: startPage * this.tagStatRows + 1,
				endIdx: startPage * this.tagStatRows + this.tagStatRows
			}
			const searchTagStatList = await searchApi.searchTagStatList(paramData)
			this.tagStatList = searchTagStatList.data
			if (searchTagStatList.data && searchTagStatList.data.length > 0) {
				this.tagStatTotalCount = searchTagStatList.data[0].totalCount
			} else {
        this.tagStatTotalCount = 0;
      }

			this.tagStatPage = currentPage
			this.pageDataSetting(currentPage, this.tagStatTotalCount, this.tagStatRows)
		},

		pagingTagStatMethod (page) {
			const startRow = page - 1
			this.searchTagStatList(page, startRow, this.tagName)
		},

		pageDataSetting (currentPage, totalCnt, rows) {
			const totalPage = Math.ceil(totalCnt / rows)
			const first = currentPage > 1 ? parseInt(currentPage, 10) - parseInt(1, 10) : null
			const end = totalPage !== currentPage ? parseInt(currentPage, 10) + parseInt(1, 10) : null

			const startIndex = (Math.ceil(currentPage / this.block) - 1) * this.block + 1
			const endIndex = startIndex + this.block > totalPage ? totalPage : startIndex + this.block - 1
			const list = []
			for (let index = startIndex; index <= endIndex; index++) {
				list.push(index)
			}
			return { first, end, list, currentPage, totalPage }
		},

		// 통계보고서 상세보기 (팝업)
		async goStatReport (data) {
			// 통계보고서 방문자수 업데이트
			this.updateVistCount(data)

			const frm = new FormData()

			frm.append('type', 'STATREPORT')
			frm.append('fileMgmNo', data.rptFileSeq)

			const statisticsData = await noticeApi.fileConvert(frm)
			const openUrl = statisticsData.data

			window.open(openUrl, '_blank')
		},

		// 통계보고서 방문자수 업데이트
		async updateVistCount (data) {
			const frm = new FormData()
			frm.append('statRptId', data.statRptId)
			statReportApi.updateStatReportVistCount(frm)
			data.visitCnt = Number(data.visitCnt) + 1
		},

		showDataMapChart () {
			this.searchTabs = 1
		},

		showCategory () {
			this.searchTabs = 2
		}
	}
}
</script>

  <style scoped>

  #subGnb>ul>li:after {
    display:none;
  }

  .result-item {
    position: relative;
  }

  .tag-list {
    display: flex;
    align-items: center;
    gap: 5px;
  }

  .tag-box {
    padding: 8px 12px;
    background-color: #e0e0e0;
    border-radius: 20px;
    color: #666;
    font-size: 14px;
    text-align: center;
    white-space: nowrap;
  }

  @media only screen and (max-width: 600px){
    .search-result-list li a {
      flex-direction: column;
    }
    .tag-list {
      margin-top: 10px;
    }
  }

  @media (max-width: 600px) {
    .tag-box {
        padding: 4px 8px;
        font-size: 10px;
    }
    .title-address .result-title {
      font-size: 14px !important;
    }
}

  .highlight-tag {
    color: #ffffff;
    background-color: #97a8d6;
    font-weight: bold;
  }

  .category-graph {
    overflow-x: auto;
  }

  .graph-item {
    margin-right: 50px;
  }

  .graph-item:hover {
    background-color: #F4F4F4;
    cursor: pointer;
  }

  </style>
